import PedidoDevolucaoMaterial from './PedidoDevolucaoMaterial';

export default PedidoDevolucaoMaterial;